import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { logger } from './utils/logger';

// Zentrales Frontend-Logging (Errors + Events landen in der Log-DB)
logger.start();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA support
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('[PWA] App ist jetzt offline verfügbar!');
  },
  onUpdate: (registration) => {
    console.log('[PWA] Neue Version verfügbar!');
  }
});
